<template>
  <div class="clueCirculationRecord common_contentBox">
    <div class="common_search">
      <el-row>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">线索ID：</div>
          <div class="content">
            <el-input v-model="form.leadId" placeholder="请输入" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">客户单位：</div>
          <div class="content">
            <el-input v-model="form.unit" placeholder="请输入" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">活动名称：</div>
          <div class="content">
            <el-input v-model="form.activityName" placeholder="请输入" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">联系电话：</div>
          <div class="content">
            <el-input v-model="form.phone" placeholder="请输入" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">客户姓名：</div>
          <div class="content">
            <el-input v-model="form.customerName" placeholder="请输入" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">线索状态：</div>
          <div class="content">
            <el-select v-model="form.poolStat" clearable placeholder="请选择">
              <el-option
                v-for="item in leadStatOptions"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">线索分类：</div>
          <div class="content">
            <el-select v-model="form.leadTypeCode" clearable placeholder="请选择">
              <el-option
                v-for="item in leadTypeOptions"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">线索反馈结果：</div>
          <div class="content">
            <el-select v-model="form.feedbackResultCode" clearable placeholder="请选择">
              <el-option
                v-for="item in feedbackResultOptions"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <div class="label">线索上传时间：</div>
          <div class="content">
            <el-date-picker
              v-model="form.time"
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
            />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" />
        <div class="btnBar">
          <el-button plain @click="reset">重置</el-button>
          <el-button type="primary" @click="searchBtn">搜索</el-button>
        </div>
      </el-row>
      <div class="advancedSearchBtn">
        <span :class="searchOpenFlag ? 'open' : ''" @click="searchOpenFlag = !searchOpenFlag">
          <span>{{ searchOpenFlag ? '收起搜索' : '高级搜索' }}</span>
          <i class="iconfont icon-rili4-icon" />
        </span>
      </div>
    </div>
    <div class="common_btnBar">
      <el-button type="primary" @click="exportHandle">导出</el-button>
    </div>
    <commonTable ref="clueCirculationRecordTable" />
  </div>
</template>

<script>
import commonTable from '@/components/commonTable';
import { TableColumns, TableRow } from '@/utils/tableOptions';
import { cluePoolListApi } from '../cluePool/service';
import axios from 'axios';
import requestBaseUrl from '@/API/request/baseUrl';

export default {
  data () {
    return {
      searchOpenFlag: false,
      form: {
        poolConfigType: 'leadTransferRecord'
      },
      leadStatOptions: [],
      leadTypeOptions: [],
      feedbackResultOptions: []
    };
  },
  components: {
    commonTable
  },
  methods: {
    exportHandle () {
      let tipsText = `确认是否导出全部线索，共${this.$refs.clueCirculationRecordTable.pageData.total}条`;
      this.$confirm(tipsText, '导出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = JSON.parse(JSON.stringify(this.form));
        if (params.time) {
          params.startTime = this.form.time[0].format('yyyy-MM-dd');
          params.endTime = this.form.time[1].format('yyyy-MM-dd');
          delete params.time;
        }
        if (params.time === null) {
          delete params.time;
        }
        axios({
          method: 'post',
          headers: {
            sysId: window._env_.VUE_APP_SYSID
          },
          withCredentials: true,
          url: `${requestBaseUrl}/lead/lead/excel`,
          responseType: 'blob',
          data: params
        }).then(response => {
          let date = new Date().format('yyyyMMddhhmmss');
          // let fileName = window.decodeURI(response.headers['content-disposition'].split('=')[1]);
          let fileName = `线索导出${ date }`;
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }));
          link.target = '_blank';
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
      }).catch(() => {

      });
    },
    detailsJump (row) {
      this.$router.push({
        path: '/clueDetails',
        query: {
          leadId: row.leadId,
          metaActive: '/clueCirculationRecord'
        }
      });
    },
    reset () {
      this.form = {
        poolConfigType: 'leadTransferRecord'
      };
      this.searchBtn();
    },
    searchBtn () {
      let params = JSON.parse(JSON.stringify(this.form));
      if (params.time) {
        params.startTime = this.form.time[0].format('yyyy-MM-dd');
        params.endTime = this.form.time[1].format('yyyy-MM-dd');
        delete params.time;
      }
      if (params.time === null) {
        delete params.time;
      }
      this.$refs.clueCirculationRecordTable.pageData.pageNum = 1;
      this.$refs.clueCirculationRecordTable.getTableData({ url: '/lead/lead/list/condition', params: params });
    },
    loadTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title('线索ID')
          ._width('140px')
          ._data('leadId')
          ._fixed('left')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <span class="btnText" onClick={() => {
                    this.detailsJump(row);
                  }}>{row.leadId}</span>
                </div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('线索分类')
          ._width('100px')
          ._data('leadTypeName')
      );
      tableRow.push(
        new TableColumns()
          ._title('活动编号')
          ._width('150px')
          ._data('activityCode')
      );
      tableRow.push(
        new TableColumns()
          ._title('活动分类')
          ._width('100px')
          ._data('activityClassificationName')
      );
      tableRow.push(
        new TableColumns()
          ._title('活动名称')
          ._width('150px')
          ._data('activityName')
      );
      tableRow.push(
        new TableColumns()
          ._title('实际线索等级')
          ._width('130px')
          ._data('classificationActualName')
      );
      tableRow.push(
        new TableColumns()
          ._title('线索上传日期')
          ._width('130px')
          ._data('uploadTime')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let date = row[column.property] ? new Date(row[column.property].replace(/-/g, '/')).format('yyyy-MM-dd') : '';
              return (
                <span>{date}</span>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('客户单位')
          ._width('150px')
          ._data('unit')
      );
      tableRow.push(
        new TableColumns()
          ._title('联系电话')
          ._width('130px')
          ._data('phone')
      );
      tableRow.push(
        new TableColumns()
          ._title('客户姓名')
          ._width('100px')
          ._data('name')
      );
      tableRow.push(
        new TableColumns()
          ._title('城市')
          ._width('100px')
          ._data('city')
      );
      tableRow.push(
        new TableColumns()
          ._title('行业')
          ._width('100px')
          ._data('industry')
      );
      tableRow.push(
        new TableColumns()
          ._title('产品线')
          ._width('130px')
          ._data('productLine')
      );
      tableRow.push(
        new TableColumns()
          ._title('备注')
          ._width('130px')
          ._data('remark')
          ._offOverFlow(true)
      );
      tableRow.push(
        new TableColumns()
          ._title('线索状态')
          ._width('130px')
          ._data('statName')
      );
      tableRow.push(
        new TableColumns()
          ._title('当前节点')
          ._width('130px')
          ._data('nodeName')
      );
      tableRow.push(
        new TableColumns()
          ._title('操作')
          ._width('120px')
          ._fixed('right')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-button type="text" onClick={() => {
                    this.detailsJump(row);
                  }}>查看
                  </el-button>
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.$refs.clueCirculationRecordTable.setColumn(column);
      this.$refs.clueCirculationRecordTable.loadTable({
        url: '/lead/lead/list/condition',
        listKey: 'list',
        params: this.form
      });
    },
    getOptionsList () {
      cluePoolListApi.getOptionsList('LEAD_TRANSFER_RECORD').then(res => {
        if (res.status === '200') {
          this.leadStatOptions = res.data.leadStatOptions;
          this.leadTypeOptions = res.data.leadTypeOptions;
          this.feedbackResultOptions = res.data.feedbackResultOptions;
        }
      });
    }
  },
  mounted () {
    this.getOptionsList();
    this.loadTable();
  }
};
</script>

<style scoped>

</style>
